import { useDialog } from 'naive-ui'

const DialogContent = () => {
  const dialog = useDialog()

  window.$dialog = dialog

  window.$confirm = (
    title: string,
    content: string,
    type: 'info' | 'warning' | 'error' | 'success' = 'info',
    confirmText = '确定',
    cancelText = '取消',
  ) =>
    new Promise((resolve) => {
      dialog.create({
        title,
        content,
        type,
        positiveText: confirmText,
        negativeText: cancelText,
        maskClosable: false,
        onPositiveClick: () => {
          resolve(true)
        },
        onNegativeClick: () => {
          resolve(false)
        },
        onClose: () => {
          resolve(false)
        },
      })
    })

  return <></>
}

export default DialogContent
